angular.
module("dx.webapp.library").
directive("dxLibraryExamItem", function libraryExamItemDirective(
) {
	"use strict";

	return {
		restrict: "E",
		require: "^^dxExamLibrary",
		scope: {
			exam: "=",
			embedded: "=",
		},
		templateUrl: "tmpl/library/library-exam-item-directive.html",
		replace: true,
		controller: "DxLibraryExamItemController",
		link: link,
	};

	function link($scope, $element, $attrs, requiredController) {
		$scope.dxExamLibraryCtrl = requiredController;
	}
});
